import { Component, OnInit, HostListener, Host, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppUtilityService } from '../common/app-utility.service'
import { AppComponent } from '../app.component';
import { EnglishTranslation, MalayTranslation } from '../app.constants';
import { DataStoreService } from '../data-store.service';

@Component({
  selector: 'app-company-details-info',
  templateUrl: './company-details-info.component.html',
  styleUrls: ['./company-details-info.component.scss']
})
export class CompanyDetailsInfoComponent implements OnInit, AfterViewInit {

  CompanyDetailsInfo: FormGroup;
  BusinessName: string;
  BusinessRegNo: string;
  BusinessType: string;
  UltimateOwners: any = [];
  BusinessAddress: string;
  Constitution: string;
  MSICList: any = [];
  SSICList: any = [];
  isDisplayMSIC: boolean = false;
  showErrorModal: boolean = false;
  textContent: any; //html contents

  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    private activeRoute: ActivatedRoute,    
    private AppUtility: AppUtilityService,
    public appComp: AppComponent,
    private dataStoreService: DataStoreService
  ) {
  }

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.CompanyDetailsInfoScreen : MalayTranslation.CompanyDetailsInfoScreen;
    
    this.CompanyDetailsInfo = this.formBuilder.group(
      {
       
      }
    )
    this.retrieveData();
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      this.dataStoreService.setAAData('company-details-info');
    }
  }

  async retrieveData() {
    var companyDetails = JSON.parse(sessionStorage.getItem('ctos-details'));
    var locStorage=JSON.parse(localStorage.getItem("URLParam"));
    // this.setData(responseData);
    var reqID = "R0015"
    var data = {    
        "BusinessName": companyDetails.CompanyList[0].BusinessName,
        "BusinessType": companyDetails.CompanyList[0].BusinessType,
        "BusinessRegNo": companyDetails.CompanyList[0].BusinessRegNo,  
        "ProductName": locStorage.ProductDescription,
        "ProductCode": locStorage.Product,
        "Language": sessionStorage.language,
        "CTOSConsentDateTime" : sessionStorage.CTOSConsentDateTime
    }
    var responseData = await this.restConnect(data, reqID);
    if (responseData.Status == "Success") {       
      this.setData(responseData);      
    }
    else {
    }   
  }
  setData(responseData){
    sessionStorage.setItem("constitution", responseData.CompanyDetails.BusinessType);
    this.BusinessName = responseData.CompanyDetails.BusinessName;
    this.BusinessRegNo = responseData.CompanyDetails.BusinessRegNo;  
    this.UltimateOwners = responseData.CompanyDetails.ConnectedParties;
    this.Constitution = responseData.CompanyDetails.Constitution;
    this.MSICList = responseData.CompanyDetails.MSICList;
    this.SSICList = responseData.SSICList;
    this.isDisplayMSIC = this.MSICList.length > 0;;

    if(responseData.CompanyDetails.BusinessType == "B"){
      this.BusinessType = "Sole Proprietorship/ Partnership";
    }else if(responseData.CompanyDetails.BusinessType == "C"){
      this.BusinessType = "Sdn Bhd";
    }else {
      this.BusinessType = "";
    }
    this.BusinessAddress = responseData.CompanyDetails.RegisteredOfficeAddress;
    sessionStorage.setItem("ConnectedParties", JSON.stringify(responseData));
    
  }

  async restConnect(data, reqID) {
    this.connect.consoleLog("data value", data)
    var ServResponse = await this.connect.connectRest(data, reqID, '');
    return ServResponse;
  }

  onBack() {
    this.router.navigate(['/info-update-your-record']);
  //this.router.navigate(['/identify-your-company']);
  }

  async onSubmit(){  
    var locStorage=JSON.parse(localStorage.getItem("URLParam"))
    var reqID = "S0015"
    var req = {        
      "Source1": locStorage.Source1,
      "Source2": locStorage.Source2,
      "ProductName": locStorage.ProductDescription,
      "ProductCode": locStorage.Product ,
      "Language": sessionStorage.language,
      "CTOSConsentDateTime" : sessionStorage.CTOSConsentDateTime            
    }
    var respData = await this.restConnect(req, reqID);
    if (respData.Status == "Success") {       
      this.router.navigate(['/tell-us']);
    }
    else {
      if(respData['errorMessage'] == 'EDRP1') {
        this.showErrorModal = true;
      }
    }      
  } 

  goToLandingPage() {
    this.dropOffServiceCall('Yes');
  }

  goToThankYouPage() {
    this.dropOffServiceCall('No');
  }

  async dropOffServiceCall(ApplyOCBCeBiz) {
    var reqID = "R0253"
    var req = {        
      ApplyOCBCeBiz    
    }
    var respData = await this.restConnect(req, reqID);
    if (respData.Status == "Success") {  
      this.showErrorModal = false;
      if(ApplyOCBCeBiz == 'Yes') {
        this.router.navigate(["/start"], { queryParams: { product: "U8",lang:sessionStorage.language }});
      } else {
        this.router.navigate(["thank-you"]);
        sessionStorage.setItem("IslamicNotEligible", "true");
      }
    }  
  }
}
